export const NON_DIGITS_WITH_DOT_PATTERN = /[^0-9.]/g;
export const NON_DIGITS_PATTERN = /[^0-9]/g;